import cn from 'classnames';

import { IconComponent } from 'components/Icon/IconComponent';

export const TitleGroup = ({
  icon,
  iconSize = 'medium',
  className,
  title,
  subTitle,
  align = 'start',
}) => {
  return (
    <div
      className={cn('flex flex-row gap-4 w-full', {
        'items-start': align === 'start',
        'items-center': align === 'center',
        'items-end': align === 'end',
      })}>
      {icon && <IconComponent icon={icon} size={iconSize} />}
      <div className="flex flex-column w-full">
        <span className="text-neutral-7 font-semibold text-[16px]">{title}</span>
        {subTitle && <p className="text-text-tertiary text-[14px] font-light">{subTitle}</p>}
      </div>
    </div>
  );
};
